import { Box, Divider, Typography } from "@mui/material";

interface SectionTitleProps {
  children: string;
  subtitle?: string;
}

export default function SectionTitle(props: SectionTitleProps) {
  return (
    <Box>
      <Typography fontWeight={400} fontSize={16} color="primary" gutterBottom>
        {props.children}
      </Typography>
      {props.subtitle && (
        <Typography variant={"subtitle1"} fontSize={11} color="grey">
          {props.subtitle}
        </Typography>
      )}
      <Divider />
    </Box>
  );
}
